var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.793 14.779v2.996c0 1.534-2.964 2.779-6.62 2.779-3.657 0-6.621-1.245-6.621-2.78v-1.407M3.68 10.95v2.996c0 1.535 2.964 2.78 6.62 2.78 3.657 0 6.62-1.245 6.62-2.78V10.95M6.552 5.208v2.996c0 1.535 2.965 2.779 6.621 2.779 3.657 0 6.621-1.244 6.621-2.78V5.209M6.552 8.784c-1.734.501-2.871 1.34-2.871 2.291 0 1.535 2.964 2.779 6.62 2.779 3.657 0 6.62-1.244 6.62-2.779 0-.122-.018-.243-.055-.361m-.444 1.768c2.013.477 3.371 1.382 3.371 2.421 0 1.535-2.964 2.78-6.62 2.78-2.075 0-3.927-.401-5.14-1.028-.14-.072-.206-.074-.328-.152m3.373-10.312-.26-.983 4.26-.002-.272-.986.542 1.971m4.445-.858c0 1.534-2.964 2.779-6.62 2.779-3.657 0-6.621-1.245-6.621-2.78 0-1.534 2.964-2.778 6.62-2.778 3.657 0 6.621 1.244 6.621 2.779Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.d71cc3bd914f928fce8487adf9719cb8.svg";
export { ForwardRef as ReactComponent };